import { WebPlugin } from '@capacitor/core';
export class CapacitorWechatWeb extends WebPlugin {
    async initialize() {
        throw this.unavailable('initialize is not available on the web.');
    }
    isInstalled() {
        return Promise.resolve({ installed: false });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    auth(_options) {
        throw new Error('Method not implemented on web platform.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    share(_options) {
        throw new Error('Method not implemented on web platform.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendPaymentRequest(_options) {
        throw new Error('Method not implemented on web platform.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    openMiniProgram(_options) {
        throw new Error('Method not implemented on web platform.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    chooseInvoice(_options) {
        throw new Error('Method not implemented on web platform.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map